import Highlight from "../components/Highlight";
import { wordStrategy } from "./inCodeLookup";
import { CompositeDecorator } from "draft-js";

const getDecorator = (words = [], onUpdate, blocks = []) => {
  const getWords = (coding) => [
    ...words
      .filter((d) => d.coding === coding)
      .sort((a, b) => a.position[0] - b.position[0]),
  ];

  let i = 0;
  let j = 0;

  let maleWords = getWords("male-coded");
  let femaleWords = getWords("female-coded");

  // // TODO:
  // Need to split words into blocks so doesn't order is correct so words are not missed

  return new CompositeDecorator([
    {
      strategy: wordStrategy(maleWords, blocks),
      props: {
        words: maleWords,
      },
      component: (props) => {
        const component = (
          <Highlight
            {...props}
            type={"masculine"}
            onUpdate={onUpdate}
            i={i}
            hasHover={true}
            phrase={props.decoratedText}
          />
        );

        i = i + 1;

        return component;
      },
    },
    {
      strategy: wordStrategy(femaleWords, blocks),
      props: {
        words: femaleWords,
      },
      component: (props) => {
        const component = (
          <Highlight
            {...props}
            type={"feminine"}
            i={j}
            onUpdate={onUpdate}
            hasHover={true}
            phrase={props.decoratedText}
          />
        );

        j = j + 1;

        return component;
      },
    },
  ]);
};

export default getDecorator;
